import GloballySelected from "../../../../common/state/modules/globallySelected";
import SingleSelectedProperty from "~/state/modules/singleSelectedProperty";
import Visualization from "~/models/visualizations/visualization";
import VisualizationSourceDataPoint from "~/models/visualizations/visualizationSourceDataPoint";
import User from "~/models/user";
import VisualizationDataFusionPoint from "~/models/visualizations/visualizationDataFusionPoint";
import VisualizationDataTableFilter from "~/models/visualizations/visualizationDataTableFilter";
import Organization from "~/models/organization";

export default class Selected extends GloballySelected {
  static currentUser = new SingleSelectedProperty('currentUser', () => User);
  static organization = new SingleSelectedProperty('organization', () => Organization)
  static visualization = new SingleSelectedProperty("visualization", () => Visualization);
  static selectedDataPoint = new SingleSelectedProperty("dataPoint", () => VisualizationDataFusionPoint as any | VisualizationSourceDataPoint as any);
  static selectedDragDataPoint = new SingleSelectedProperty('selectedDragDataPoint', () => VisualizationDataFusionPoint as any | VisualizationSourceDataPoint as any);
  static selectedDataTableFilter = new SingleSelectedProperty('dataTableFilter', () => VisualizationDataTableFilter);
}